import React from 'react';
import { Prompt } from 'react-router-dom';
import Modal from './Modal';
import {DialogContent, DialogContentText, Typography} from '@material-ui/core';
import {WarningOutlined as WarningOutlineIcon} from '@material-ui/icons';

export default class RouteBlocker extends React.Component {
    state = {
        modalVisible: false,
        lastLocation: null,
        confirmedNavigation: false,
    };

    showModal = (location) => this.setState({
        modalVisible: true,
        lastLocation: location,
    });

    closeModal = (callback) => this.setState({
        modalVisible: false
    }, callback);

    handleBlockedNavigation = (nextLocation) => {
        const {confirmedNavigation} = this.state;
        const {shouldBlockNavigation} = this.props;
        if (!confirmedNavigation && shouldBlockNavigation(nextLocation)){
            this.showModal(nextLocation);
            return false;
        }

        return true;
    };

    handleConfirmNavigationClick = () => this.closeModal(() => {
        const {navigate} = this.props;
        const {lastLocation} = this.state;
        if (lastLocation) {
            this.setState({
                confirmedNavigation: true
            }, () => {
                // Navigate to the previous blocked location with your navigate function
                navigate(lastLocation.pathname);
            });
        }
    });

    render() {
        const { when, messageHeading, message, swapConfirmClose=false, confirmButtonText, cancelButtonText,
            iconComponent: IconComponent} = this.props;
        const { modalVisible } = this.state;
        return (
            <>
                <Prompt
                    when={ when }
                    message={this.handleBlockedNavigation}/>
                <Modal
                    title=""
                    onClose={() => this.closeModal()}
                    open={modalVisible}
                    fullWidth={false}
                    maxWidth={'xl'}
                    overflowVisible={true}
                    onConfirm={this.handleConfirmNavigationClick}
                    confirmButtonText={confirmButtonText}
                    cancelButtonText={cancelButtonText}
                    swapConfirmClose={swapConfirmClose}
                >
                    <Typography align="center" color="primary" gutterBottom>
                        <IconComponent style={{width: '6rem', height: '6rem'}}/>
                    </Typography>
                    <Typography variant="h5" align="center" color="primary" gutterBottom>{messageHeading}</Typography>
                    <DialogContentText align="center">{message}</DialogContentText>
                </Modal>
            </>
        );
    }
}
